import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {DATALAKE_CVM_CADASTRO_EMPRESAS_PATH} from 'src/utils/api-routes'
import ParameterDatalakeCVMCadastroEmpresasTable
    from 'src/pages/parameters/parameters-datalake/tables/parameter-datalake-cvm-cadastro-empresas-table'

const TableCadastroCvm = ({loading, empresa}) => {

    const PAGE_DEFAULT_SIZE = 25
    const PAGE_DEFAULT_INIT = 0
    const [pagination] = useState({init: PAGE_DEFAULT_INIT, end: PAGE_DEFAULT_SIZE})

    return <ParameterDatalakeCVMCadastroEmpresasTable
        customFilter={false}
        disableToolbar={true}
        filters={[{field: 'CPFCNPJ', value: empresa}]}
        endpoint={`${DATALAKE_CVM_CADASTRO_EMPRESAS_PATH}?`}
        loading={loading}
        pagination={pagination}
    />
}

TableCadastroCvm.propTypes = {
    loading: PropTypes.func,
    empresa: PropTypes.object,
}

export default TableCadastroCvm